module.exports = __webpack_public_path__ + "img/Dantam Makeover 15.a393ca9a.jpg";